import { Activity, Wrench, Bell, Cpu, Sparkles } from "lucide-react";

const iconFor = (type) => {
  if (type === "ack_alarm") return Bell;
  if (type === "write_tag") return Wrench;
  if (type === "hint") return Sparkles;
  if (type === "system") return Cpu;
  return Activity;
};

export default function EventTimeline({ events }) {
  const ordered = [...events].reverse();
  return (
    <div className="bg-card border border-border/60 rounded-md flex flex-col h-full" data-testid="event-timeline">
      <div className="px-3 py-2 border-b border-border/60 flex items-center justify-between bg-popover">
        <span className="label-ot">Action Timeline</span>
        <span className="font-mono text-xs text-muted-foreground">{events.length} EVENTS</span>
      </div>
      <div className="flex-1 overflow-y-auto max-h-[200px] p-2 space-y-1">
        {ordered.map((e, i) => {
          const Icon = iconFor(e.type);
          const t = new Date(e.timestamp);
          const ts = isNaN(t) ? "" : t.toLocaleTimeString([], { hour12: false });
          return (
            <div key={i} data-testid="timeline-event" className="flex gap-2.5 px-2 py-1.5 text-xs">
              <Icon className="w-3.5 h-3.5 text-primary shrink-0 mt-0.5" />
              <div className="flex-1">
                <span className="font-mono text-[10px] text-muted-foreground mr-2">{ts}</span>
                <span className="text-foreground/90">{e.description}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
